__turbopack_context__.v({
  "drawer-footer-slide-up": "ChangeOriginModal-module__lYh4dW__drawer-footer-slide-up",
  "drawerBack": "ChangeOriginModal-module__lYh4dW__drawerBack",
  "drawerFooter": "ChangeOriginModal-module__lYh4dW__drawerFooter",
  "drawerFooterCol": "ChangeOriginModal-module__lYh4dW__drawerFooterCol",
  "drawerFooterConfirm": "ChangeOriginModal-module__lYh4dW__drawerFooterConfirm",
  "drawerHeader": "ChangeOriginModal-module__lYh4dW__drawerHeader",
  "drawerList": "ChangeOriginModal-module__lYh4dW__drawerList",
  "drawerOriginRow": "ChangeOriginModal-module__lYh4dW__drawerOriginRow",
  "drawerRegionRow": "ChangeOriginModal-module__lYh4dW__drawerRegionRow",
  "drawerRoot": "ChangeOriginModal-module__lYh4dW__drawerRoot",
  "drawerTitle": "ChangeOriginModal-module__lYh4dW__drawerTitle",
  "helperText": "ChangeOriginModal-module__lYh4dW__helperText",
  "optionSpinner": "ChangeOriginModal-module__lYh4dW__optionSpinner",
  "originList": "ChangeOriginModal-module__lYh4dW__originList",
  "originPill": "ChangeOriginModal-module__lYh4dW__originPill",
  "popoverBackHeading": "ChangeOriginModal-module__lYh4dW__popoverBackHeading",
  "popoverHeading": "ChangeOriginModal-module__lYh4dW__popoverHeading",
  "popoverLoading": "ChangeOriginModal-module__lYh4dW__popoverLoading",
  "popoverView": "ChangeOriginModal-module__lYh4dW__popoverView",
  "regionList": "ChangeOriginModal-module__lYh4dW__regionList",
  "regionPill": "ChangeOriginModal-module__lYh4dW__regionPill",
});
